import React from 'react';

export interface CoreContextProps {
  serverUri: string;
  graphQLUrl: string;
  clientUri: string;
  parentClientUri: string;
}

export const CoreConfigContext = React.createContext<CoreContextProps>({
  serverUri: '',
  graphQLUrl: '',
  clientUri: '',
  parentClientUri: '',
});
